import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import { configureStore } from '@reduxjs/toolkit'

import { api } from './api/api'
import * as auth from './auth'
import * as market from './market'
import * as orders from './orders'
import { socketMiddleware } from './socketMiddleware'

export const store = configureStore({
  reducer: {
    [auth.slice.name]: auth.slice.reducer,
    [market.slice.name]: market.slice.reducer,
    [orders.slice.name]: orders.slice.reducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware).concat(socketMiddleware),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
